
import svgPaths from '../imports/svg-2zi4snz1xq';


export const ClockIcon = () => (
  <div className="absolute left-[11px] size-[42px] top-0">
    <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 42 42">
      <g id="Frame 1321319050">
        <circle cx="21" cy="21" fill="var(--fill-0, #F5F1FD)" id="Ellipse 2365" r="21" />
        <g id="Apps">
          <path d={svgPaths.p25192ab0} fill="var(--fill-0, #906CD8)" id="Vector" />
          <path d={svgPaths.pfc96ec0} fill="var(--fill-0, #F5F1FD)" id="Vector_2" />
          <path d={svgPaths.p2d570980} fill="var(--fill-0, black)" id="Vector_3" />
          <path d={svgPaths.p298adf0} fill="var(--fill-0, black)" id="Vector_4" />
          <path d={svgPaths.p35aa1200} fill="var(--fill-0, black)" id="Vector_5" />
          <path d={svgPaths.p54b8d00} fill="var(--fill-0, #906CD8)" id="Vector_6" />
        </g>
      </g>
    </svg>
  </div>
);

export const WeatherIcon = () => (
  <div className="absolute left-[11px] size-[42px] top-0">
    <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 42 42">
      <g id="Frame 1321319050">
        <circle cx="21" cy="21" fill="var(--fill-0, #EAF6EC)" id="Ellipse 2365" r="21" />
        <g id="Apps">
          <path d={svgPaths.p22336280} fill="var(--fill-0, #24983F)" id="Vector" />
        </g>
      </g>
    </svg>
  </div>
);

export const RSSFeedIcon = () => (
  <div className="absolute left-[11px] size-[42px] top-0">
    <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 42 42">
      <g id="Frame 1321319050">
        <circle cx="21" cy="21" fill="var(--fill-0, #FEF6E8)" id="Ellipse 2365" r="21" />
        <g id="Apps">
          <path d={svgPaths.p9615f00} fill="var(--fill-0, #DD9316)" id="Vector" />
        </g>
      </g>
    </svg>
  </div>
);

export const GoogleSheetIcon = () => (
  <div className="absolute left-[11px] size-[42px] top-0">
    <div className="absolute left-0 size-[42px] top-0">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 42 42">
        <circle cx="21" cy="21" fill="var(--fill-0, #EAF6EC)" id="Ellipse 2365" r="21" />
      </svg>
    </div>
    <div className="absolute left-[9px] size-[24px] top-[9px]" data-name="Apps">
      <div className="absolute h-[24px] left-1/2 overflow-clip top-1/2 translate-x-[-50%] translate-y-[-50%] w-[18px]" data-name="Google_Sheets_logo">
        <div className="absolute contents inset-[1.43%_1.7%]" data-name="Page-1">
          <div className="absolute contents inset-[1.43%_1.7%]" data-name="Consumer-Apps-Sheets-Large-VD-R8-">
            <div className="absolute contents inset-[1.43%_1.7%]" data-name="Hero">
              <div className="absolute contents inset-[1.43%_1.7%]" data-name="Personal">
                <div className="absolute contents inset-[1.43%_1.7%]" data-name="Sheets-icon">
                  <div className="absolute contents inset-[1.43%_1.7%]" data-name="Group">
                    <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 17.3878 23.3134">
                      <path d={svgPaths.p1270b960} fill="#0F9D58" />
                      <path d={svgPaths.p2680ec00} fill="#F1F1F1" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export const GoogleSlidesIcon = () => (
  <div className="absolute left-[11px] size-[42px] top-0">
    <div className="absolute left-0 size-[42px] top-0">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 42 42">
        <circle cx="21" cy="21" fill="var(--fill-0, #FEF6E8)" id="Ellipse 2365" r="21" />
      </svg>
    </div>
    <div className="absolute left-[9px] size-[24px] top-[9px]">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 16.7639 23.6667">
        <path d={svgPaths.p2cf78700} fill="#F4B400" />
      </svg>
    </div>
  </div>
);

export const TextIcon = () => (
  <div className="absolute left-[11px] size-[42px] top-0">
    <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 42 42">
      <g id="Frame 1321319050">
        <circle cx="21" cy="21" fill="var(--fill-0, #F0F2F5)" id="Ellipse 2365" r="21" />
        <g id="Apps">
          <path d={svgPaths.p989c200} fill="var(--fill-0, #101928)" id="Vector" />
        </g>
      </g>
    </svg>
  </div>
);

export const SocialWallIcon = () => (
  <div className="absolute left-[11px] size-[42px] top-0">
    <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 42 42">
      <g id="Frame 1321319050">
        <circle cx="21" cy="21" fill="var(--fill-0, #FFECE5)" id="Ellipse 2365" r="21" />
        <g id="Apps">
          <path d={svgPaths.p7238e80} fill="var(--fill-0, #DA3E33)" id="Vector" />
        </g>
      </g>
    </svg>
  </div>
);

export const ScrollerIcon = () => (
  <div className="absolute left-[11px] size-[42px] top-0">
    <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 42 42">
      <g id="Frame 1321319050">
        <circle cx="21" cy="21" fill="var(--fill-0, #F0F2F5)" id="Ellipse 2365" r="21" />
        <g id="Apps">
          <path d={svgPaths.p28082d80} fill="var(--fill-0, #101928)" id="Vector" />
        </g>
      </g>
    </svg>
  </div>
);

export const FacebookIcon = () => (
  <div className="absolute left-[11px] size-[42px] top-0">
    <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 42 42">
      <g id="Frame 1321319050">
        <circle cx="21" cy="21" fill="var(--fill-0, #1877F2)" id="Ellipse 2365" r="21" />
        <g id="Apps">
          <path d={svgPaths.p33b0d080} fill="white" />
          <path d={svgPaths.p2ba8e700} fill="#1877F2" />
        </g>
      </g>
    </svg>
  </div>
);

export const TOINewsIcon = () => (
  <div className="absolute left-[11px] size-[42px] top-0">
    <div className="absolute left-0 size-[42px] top-0">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 42 42">
        <circle cx="21" cy="21" fill="var(--fill-0, #E21B22)" id="Ellipse 2365" r="21" />
      </svg>
    </div>
    <div className="absolute left-[9px] overflow-clip size-[24px] top-[9px]" data-name="Apps">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 24 24">
        <g id="Group">
          <path d={svgPaths.p3f2cde00} fill="var(--fill-0, #E21B22)" id="Vector" />
          <path d={svgPaths.p21c63680} fill="var(--fill-0, white)" id="Vector_2" />
        </g>
      </svg>
    </div>
  </div>
);

export const ESPNNewsIcon = () => (
  <div className="absolute left-[11px] size-[42px] top-0">
    <div className="absolute left-0 size-[42px] top-0">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 42 42">
        <circle cx="21" cy="21" fill="var(--fill-0, #CC0000)" id="Ellipse 2365" r="21" />
      </svg>
    </div>
    <div className="absolute left-[9px] overflow-clip size-[24px] top-[9px]" data-name="Apps">
      <div className="absolute inset-[37.67%_-0.01%_37.68%_0.01%]" data-name="XMLID_1_">
        <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 23.9999 5.91455">
          <path d={svgPaths.pa263200} fill="var(--fill-0, white)" />
        </svg>
      </div>
    </div>
  </div>
);

export const CNNNewsIcon = () => (
  <div className="absolute left-[11px] size-[42px] top-0">
    <div className="absolute left-0 size-[42px] top-0">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 42 42">
        <circle cx="21" cy="21" fill="var(--fill-0, #D81921)" id="Ellipse 2365" r="21" />
      </svg>
    </div>
    <div className="absolute left-[9px] overflow-clip size-[24px] top-[9px]" data-name="Apps">
      <div className="absolute contents inset-[26.21%_0.02%_26.19%_-0.02%]" data-name="Group">
        <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 24.0004 11.4242">
          <path d={svgPaths.pa692bc0} fill="var(--fill-0, white)" />
        </svg>
      </div>
    </div>
  </div>
);

export const CNNLatinoIcon = () => (
  <div className="absolute left-[11px] size-[42px] top-0">
    <div className="absolute left-0 size-[42px] top-0">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 42 42">
        <circle cx="21" cy="21" fill="var(--fill-0, #D81921)" id="Ellipse 2365" r="21" />
      </svg>
    </div>
    <div className="absolute left-[9px] overflow-clip size-[24px] top-[9px]" data-name="Apps">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 23.9999 22.7077">
        <g id="XMLID_1_">
          <path d={svgPaths.p1b609900} fill="var(--fill-0, white)" />
          <path d={svgPaths.p2e181600} fill="var(--fill-0, white)" />
          <path d={svgPaths.p16934d00} fill="var(--fill-0, white)" />
          <path d={svgPaths.p2cf2cac0} fill="var(--fill-0, white)" />
        </g>
      </svg>
    </div>
  </div>
);

export const NDTVIcon = () => (
  <div className="absolute left-[11px] size-[42px] top-0">
    <div className="absolute left-0 size-[42px] top-0">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 42 42">
        <circle cx="21" cy="21" fill="var(--fill-0, black)" id="Ellipse 2365" r="21" />
      </svg>
    </div>
    <div className="absolute left-[9px] overflow-clip size-[24px] top-[9px]" data-name="Apps">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 23.9996 4.53492">
        <path d={svgPaths.p35bc9800} fill="var(--fill-0, white)" />
        <path d={svgPaths.p20f58c00} fill="var(--fill-0, white)" />
        <path d={svgPaths.p35968680} fill="var(--fill-0, #EE0000)" />
      </svg>
    </div>
  </div>
);

export const FoxNewsIcon = () => (
  <div className="absolute left-[11px] size-[42px] top-0">
    <div className="absolute left-0 size-[42px] top-0">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 42 42">
        <circle cx="21" cy="21" fill="var(--fill-0, #003366)" id="Ellipse 2365" r="21" />
      </svg>
    </div>
    <div className="absolute left-[9px] overflow-clip size-[24px] top-[9px]" data-name="Apps">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 24 24">
        <path d="M0 0H24V19.4662H0V0Z" fill="var(--fill-0, #003366)" />
        <path d="M0 19.7325H24V24H0V19.7325Z" fill="var(--fill-0, #C20017)" />
        <path d={svgPaths.p9338c00} fill="var(--fill-0, white)" />
        <path d={svgPaths.p3630b00} fill="var(--fill-0, white)" />
      </svg>
    </div>
  </div>
);

export const InstagramIcon = () => (
  <div className="absolute left-[11px] size-[42px] top-0">
    <div className="absolute left-0 size-[42px] top-0">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 42 42">
        <circle cx="21" cy="21" fill="url(#paint0_radial_instagram)" id="Ellipse 2365" r="21" />
        <defs>
          <radialGradient cx="0" cy="0" gradientTransform="translate(21 21) rotate(90) scale(21)" gradientUnits="userSpaceOnUse" id="paint0_radial_instagram" r="1">
            <stop stopColor="#FFDD55" />
            <stop offset="0.1" stopColor="#FFDD55" />
            <stop offset="0.5" stopColor="#FF543E" />
            <stop offset="1" stopColor="#C837AB" />
          </radialGradient>
        </defs>
      </svg>
    </div>
    <div className="absolute left-[9px] overflow-clip size-[24px] top-[9px]" data-name="Apps">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 18.75 18.7502">
        <path d={svgPaths.p21212780} fill="var(--fill-0, white)" />
      </svg>
    </div>
  </div>
);

export const BBCNewsIcon = () => (
  <div className="absolute left-[11px] size-[42px] top-0">
    <div className="absolute left-0 size-[42px] top-0">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 42 42">
        <circle cx="21" cy="21" fill="var(--fill-0, #9D0A0E)" id="Ellipse 2365" r="21" />
      </svg>
    </div>
    <div className="absolute left-[9px] overflow-clip size-[24px] top-[9px]" data-name="Apps">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 24 18.0623">
        <path d="M24 0H0V18.0623H24V0Z" fill="var(--fill-0, #9D0A0E)" />
        <path d={svgPaths.p36ff0100} fill="var(--fill-0, white)" />
        <path d={svgPaths.p3a651900} fill="var(--fill-0, white)" />
        <path d={svgPaths.p6547500} fill="var(--fill-0, white)" />
      </svg>
    </div>
  </div>
);
